
    <cms-geodestino city="Vigo" initial="comer"></cms-geodestino>
  